import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import SwitchToggle from "../../components/SwitchToggle";
import { usePermission } from "../../hooks/usePermission";
import Can from "../../components/Can";
import AddIcon from "@mui/icons-material/Add";
import AddBlogCategory from "../../Modals/addBlogCategory";

const ManageBlogCategories = () => {
  const navigate = useNavigate();
  const { hasPermission } = usePermission();
  const canEdit = hasPermission("Blog Management", "isEdit");
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const categories = [
    { id: 1, name: "Tips & Tricks for Buying Used Cars", createdDate: "01-Sept-2025", status: true },
    { id: 2, name: "Tips for Reducing Costs", createdDate: "02-Sept-2025", status: true },
    { id: 3, name: "Misconceptions and Legal Situation", createdDate: "03-Sept-2025", status: true },
    { id: 4, name: "Car, Heavy Vehicle, and Motorcycle Licenses", createdDate: "04-Sept-2025", status: false },
    { id: 5, name: "Commuter Allowance", createdDate: "05-Sept-2025", status: true },
    { id: 6, name: "Emission Standards", createdDate: "06-Sept-2025", status: true },
  ];

  return (
    <>
      {/* PAGE TITLE */}
      <CommonBreadcrumb
        title="Blog Categories"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Blog Categories" },
        ]}
      />

      <div className="cards">
        {/* TABLE HEADER */}
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Can module="Blog Management" action="isAdd" isDisabledMode={true}>
              <Button
                className="btn btn_primary"
                onClick={() => setOpenModal(true)}
              >
                <AddIcon /> Add Blog Category
              </Button>
            </Can>
          </div>
        </div>

        {/* TABLE */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Disable/Enable</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {categories.map((category, index) => (
                <TableRow hover key={category.id}>

                  {/* SR NO */}
                  <TableCell>{index + 1}</TableCell>

                  {/* CATEGORY */}
                  <TableCell>
                    <div className="user_block">
                      <p>
                        <b>{category.name}</b>
                      </p>
                    </div>
                  </TableCell>

                  {/* CREATED DATE */}
                  <TableCell>{category.createdDate}</TableCell>

                  {/* STATUS */}
                  <TableCell>
                    {canEdit ? (
                      <SwitchToggle defaultChecked={category.status} />
                    ) : (
                      <span className={`status_btn ${category.status ? "c_dark_info" : "c_dark_warning"}`}>
                        {category.status ? "Enabled" : "Disabled"}
                      </span>
                    )}
                  </TableCell>

                  {/* ACTIONS */}
                  <TableCell>
                    <div className="table_actions v2">
                      <Can module="Blog Management" action="isEdit" isDisabledMode={true}>
                        <Tooltip title="Edit" arrow>
                          <IconButton onClick={() => setOpenModal(true)}>
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Edit"
                            />
                          </IconButton>
                        </Tooltip>
                      </Can>
                      <Can module="Blog Management" action="isDelete" isDisabledMode={true}>
                        <Tooltip title="Delete" arrow>
                          <IconButton>
                            <img
                              src="/static/images/trash2_icon.svg"
                              alt="Delete"
                            />
                          </IconButton>
                        </Tooltip>
                      </Can>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* ADD / EDIT MODAL */}
      <AddBlogCategory
        open={openModal}
        onClose={() => setOpenModal(false)}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageBlogCategories;
